import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);


export const msalInstanceInitialized = msalInstance.initialize();

export const getUserInfo = () => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    return {
      name: accounts[0].name || "",
      email: accounts[0].username || "",
    };
  }
  return {
    name: "",
    email: "",
  };
};